import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChefHat, Menu, X, User } from 'lucide-react';
import '../Header/Header.css';

interface HeaderProps {
  isLoggedIn: boolean;
  onLogout: () => void;
  hideAuthButtons?: boolean;
}

const Header: React.FC<HeaderProps> = ({ isLoggedIn, onLogout, hideAuthButtons = false }) => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSignOut = () => {
    onLogout();
    navigate('/', { replace: true });
  };

  return (
    <header className="header-container">
      <Link to="/" className="logo">
        <ChefHat size={24} />
        <span>HomeCookt</span>
      </Link>

      <button className="menu-button" onClick={toggleMenu}>
        <Menu size={24} />
      </button>

      <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
        <button className="close-button" onClick={toggleMenu}>
          <X size={24} />
        </button>

        <ul className="nav-list">
          <li className="nav-item">
            <Link to={isLoggedIn ? "/home" : "/"} onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/about" onClick={() => setIsMenuOpen(false)}>About Us</Link>
          </li>
          <li className="nav-item">
            <a href="https://wa.me/447737024736" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>Contact</a>
          </li>

          {!hideAuthButtons && !isLoggedIn ? (
            <>
              <li className="nav-item">
                <Link
                  to="/login"
                  className="auth-button1 login"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Log In
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/signup"
                  className="auth-button1 signup"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sign Up
                </Link>
              </li>
            </>
          ) : !hideAuthButtons ? (
            <>
              <li className="nav-item">
                <Link
                  to="/profile"
                  className="profile-link"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <User size={16} />
                  Profile
                </Link>
              </li>
              <li className="nav-item">
                <button
                  className="auth-button1 login"
                  onClick={() => {
                    handleSignOut();
                    setIsMenuOpen(false);
                  }}
                >
                  Sign Out
                </button>
              </li>
            </>
          ) : (
            <li className="nav-item">
              <button
                className="auth-button1 login"
                onClick={() => {
                  onLogout();
                  setIsMenuOpen(false);
                }}
              >
                Sign Out
              </button>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;